module.exports = __webpack_public_path__ + "img/logo_23.ffdaf913.png";